import styled from 'styled-components/macro';

import { purple500 } from '../../../../../../../config/colors';

export const Wrapper = styled.div`
  padding: 5px;
  background-color: ${({ backgroundColor }) => backgroundColor ?? purple500};
  border-radius: 2px;
`;
